import { render } from "./TheQuizBoard.vue?vue&type=template&id=fb0ef266&scoped=true&ts=true"
import script from "./TheQuizBoard.vue?vue&type=script&lang=ts"
export * from "./TheQuizBoard.vue?vue&type=script&lang=ts"

import "./TheQuizBoard.vue?vue&type=style&index=0&id=fb0ef266&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0ef266"]])

export default __exports__